import "./Home.module.css";
import SicherheitHeader from "@/reusable_sections/Header";
import ElevateYourCreativePresence from "./sections/ElevateYourCreativePresence";
import TheViralityEngine from "./sections/TheViralityEngine";
import CategoryGrid from "./sections/CategoryGrid";
import VisualNarrative from "./sections/VisualNarrative";
import VoicesOfSuccess from "./sections/VoicesOfSuccess";
import ServiceAreas from "./sections/ServiceAreas";
import TellUsAboutYourDreamTrip from "./sections/TellUsAboutYourDreamTrip";
import Projects from "./sections/Projects";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <SicherheitHeader />
      <ElevateYourCreativePresence />
      <TheViralityEngine />
      <CategoryGrid />
      <VisualNarrative />
      <Projects />
      <VoicesOfSuccess />
      <ServiceAreas />
      <TellUsAboutYourDreamTrip />
      <Footer />
    </div>;
}